import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LanguageComponent} from './language/language.component';
import {TranslateModule} from '@ngx-translate/core';
import {ReactiveFormsModule} from '@angular/forms';

@NgModule({
  declarations: [
    LanguageComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule
  ],
  exports: [
    LanguageComponent
  ]
})
export class TranslationsModule { }
